import React from "react";
import Team from "./Components/Team";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import bg1 from "./Images/bg_1.jpg";
import bg2 from "./Images/01.jpg";
import ownerimg from "./Images/OwnerImage.jpg";
import FounderInfo from "./Components/FounderInfo";
import Offer from "./Components/Offer";
import "./CSS/Aboutpage.css";
import Loader from "./Components/Loader";
import Smdisplay from "./Components/SMdisplay";

const Aboutpage=()=>{
    return(
        <>
  <title>JanuShree - Free Bootstrap 4 Template by Colorlib</title>
  <meta charSet="utf-8" />
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1, shrink-to-fit=no"
  />
  <link
    href="https://fonts.googleapis.com/css?family=Montserrat:300,400,600,700"
    rel="stylesheet"
  />
  <link rel="stylesheet" href="css/open-iconic-bootstrap.min.css" />
  <link rel="stylesheet" href="css/animate.css" />
  <link rel="stylesheet" href="css/owl.carousel.min.css" />
  <link rel="stylesheet" href="css/owl.theme.default.min.css" />
  <link rel="stylesheet" href="css/magnific-popup.css" />
  <link rel="stylesheet" href="css/aos.css" />
  <link rel="stylesheet" href="css/ionicons.min.css" />
  <link rel="stylesheet" href="css/bootstrap-datepicker.css" />
  <link rel="stylesheet" href="css/jquery.timepicker.css" />
  <link rel="stylesheet" href="css/flaticon.css" />
  <link rel="stylesheet" href="css/icomoon.css" />
  <link rel="stylesheet" href="css/style.css" />
  {/* <div
    className="hero-wrap js-fullheight"
    style={{ backgroundImage: `url(${bg1})` }}
    data-stellar-background-ratio="0.5"
  >
    <div className="overlay" />
    <div className="container">
      <div
        className="row no-gutters slider-text js-fullheight align-items-center justify-content-center"
        data-scrollax-parent="true"
      >
        <div
          className="col-md-8 ftco-animate text-center"
          data-scrollax=" properties: { translateY: '70%' }"
        >
          <div className="icon">
            <a href="index.html" className="logo">
              <span className="flaticon-flower" />
              <h1>JanuShree</h1>
            </a>
          </div>
          <h1
            className="mb-3 mt-5 bread"
            data-scrollax="properties: { translateY: '30%', opacity: 1.6 }"
          >
            About
          </h1>
          <p
            className="breadcrumbs"
            data-scrollax="properties: { translateY: '30%', opacity: 1.6 }"
          >
            <span className="mr-2">
              <a href="index.html">Home</a>
            </span>{" "}
            <span>About</span>
          </p>
        </div>
      </div>
    </div>
  </div> */}
  <Header/>
  {/* END nav */}
  <section className="ftco-section ftco-aboutsection">
    <div className="container">
      <div className="row d-flex">
        <div className="col-md-6 d-flex ftco-animate">
          <div
            className="img img-about align-self-stretch"
            style={{ backgroundImage: `url(${bg2})`, width: "100%" }}
          />
        </div>
        <div className="col-md-6 pl-md-5 ftco-animate">
          <h2 className="mb-4 abouth2 blackthemegradient">About Us</h2>
          <p className="text-justify text-white">
          At Janushree Beauty Salon, we believe that beauty is an expression of your unique personality and confidence. Our salon is dedicated to providing an exceptional experience tailored to meet the individual needs of each client.
          </p>
          <p className="text-justify text-white">
          we believe that beauty is a reflection of self-care and confidence. Located in the heart of Chennai, our salon offers a wide range of professional beauty services tailored to enhance your natural beauty. From rejuvenating facials and luxurious hair treatments to flawless makeup and expert nail services, our skilled team is dedicated to providing you with an exceptional experience. We prioritize the use of high-quality products and the latest techniques to ensure you leave our salon feeling refreshed, revitalized, and radiant. Join us in celebrating your beauty and let us help you shine on every occasion!
          </p>
        </div>
      </div>
    </div>
  </section>
  <FounderInfo/>
  {/* <Team/> */}
  {/* <Offer/> */}
  <Smdisplay/>
  <Loader/>
  <Footer/>
  {/* loader */}
  {/* <div id="ftco-loader" className="show fullscreen">
    <svg className="circular" width="48px" height="48px">
      <circle
        className="path-bg"
        cx={24}
        cy={24}
        r={22}
        fill="none"
        strokeWidth={4}
        stroke="#eeeeee"
      />
      <circle
        className="path"
        cx={24}
        cy={24}
        r={22}
        fill="none"
        strokeWidth={4}
        strokeMiterlimit={10}
        stroke="#F96D00"
      />
    </svg>
  </div> */}
</>

    );
}

export default Aboutpage;